/**
 * React Query hook — Resume search.
 * Enabled only when a non-empty query has been submitted (search-on-submit).
 */

import { useQuery } from '@tanstack/react-query';
import { RecruitmentApiService } from '../../../services/recruitmentApi';

export const useResumeSearch = (query: string) => {
	const q = query.trim();
	return useQuery({
		queryKey: ['recruitment', 'resumes', 'search', q],
		enabled: q.length > 0,
		queryFn: async () => {
			const resp = await RecruitmentApiService.searchResumes(q);
			return resp.data; // { query, count, results }
		},
	});
};
